import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

const API_FILEUPLOAD_URL = '/api/qntcal';
interface UploadResponse {
  message?: string;
  error?: string;
}
@Injectable({
  providedIn: 'root'
})
export class ParentService {

  constructor(private http: HttpClient) { }

  // Upload file
  uploadFile(file: File): Observable<UploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<UploadResponse>(`${API_FILEUPLOAD_URL}/uploadMccbQntcal`, formData).pipe(
      catchError((error) => {
        console.error('Upload error:', error);
        return throwError(() => new Error('File upload failed'));
      })
    );
  }

  uploadEnclosure(file: File): Observable<any> {
    console.log("file", file);
    const formData = new FormData();
    formData.append('file', file); // Append file to the form data
    console.log("formData", formData);
    return this.http.post(`${API_FILEUPLOAD_URL}/upload-enclosure-file`, formData);
  }

  fetchParents(): Observable<any> {
    return this.http.get<any>(`${API_FILEUPLOAD_URL}/get-parents-with-children`);
  }

  fetchMainItems(): Observable<any> {
    return this.http.get<any>(`${API_FILEUPLOAD_URL}/get-enclosure-with-accessories`);
  }
}